import Vue from 'vue'
import axios from './axios'

Vue.directive('tracker', {
  bind: function (el, binding, vnode) {
    const { context: { $route } } = vnode
    el.addEventListener('click', () => {
      axios.post('/tracker', {
        action: 'click',
        value: binding.value,
        page: $route.name,
        path: $route.path
      })
    })
  }
})